// import 'babel-polyfill'
import '@babel/polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import 'normalize.css/normalize.css'
import './images/icon.gif'

import { Router, browserHistory } from 'react-router'
import routeFactory from "./routes";
import * as fbTag from './utility/fb'
import * as twTag from './utility/twitter'
import * as slopejetTag from './utility/slopejet'
import * as versaTag from './utility/versa'
import * as browser from './utility/browser'
import { logOrThrowError } from "./utility/logging"

// This file is only supposed to be run client side. It specifically configures
// route changes to trigger various javascript tags, and sets up the app to use
// preloaded data. Therefore, we should error hard if we're not running this
// client side, while telling eslint that the globals will be there otherwise.
/* global window:false, document:false */
if(typeof window === "undefined" || typeof document === "undefined") {
  throw new Error("Client app configuration must be run in a web browser.");
}

fbTag.load()
twTag.load()
browser.init()

const pageTrackingHOC = (PageComponent) => (
  class MiddlewareComponent extends React.Component {
    componentDidMount() {
      /* eslint-disable no-undef */
      // Google remarketing
      typeof window.google_trackConversion === 'function' &&
        window.google_trackConversion({
          google_conversion_id: 878503069,
          google_custom_params: window.google_tag_params,
          google_remarketing_only: true
        });

      typeof fbq !== "undefined" && fbq('track', 'PageView')
      typeof twq !== "undefined" && twq('track','PageView')
      /* eslint-enable no-undef */

      // These tags need to be reloaded on every pageview,
      // which means adding and removing their script tag from the DOM,
      // because it's not clear that they're designed to work with SPAs,
      // whereas the GA, Google Remarketing, FB, and Twitter tags are.
      slopejetTag.load();
      versaTag.load();

      // If any of our tags weren't there as expected,
      // log it so we know something might be misconfigured.
      // Note: we must use typeof to not trigger a ReferenceError.
      const typeofTrackingVars = [
        typeof window.google_trackConversion, typeof fbq, typeof twq
      ];

      if(typeofTrackingVars.some(it => it === 'undefined')) {
        logOrThrowError(new Error(
          "One or more tracking variables was unexpectedly undefined. " +
          "Make sure your tracking code is configured correctly. " +
          "Tracking variable statuses for remarketing, fb, and twitter " +
          `respectively were: ${typeofTrackingVars.join(', ')}.`
        ));
      }
    }

    render() {
      return <PageComponent {...this.props} />
    }
  }
);

// window.__PRELOADED_DATA__ is data that may be provided by the server
// for the initial render.
const routes = routeFactory(pageTrackingHOC, window.__PRELOADED_DATA__);

const App = () =>
  <Router routes={routes} onUpdate={() => window.scrollTo(0, 0)} history={browserHistory}></Router>

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./client/index.js